<span class="pill pill--{{ type }} pill--{{ size }}"
  ><ng-content></ng-content
></span>
